// extracted by mini-css-extract-plugin
module.exports = {"popover":"_fd9cb9a","closeIcon":"_c737e44","columnSettings":"_b469177"};